<div class="header-container">
  <div>
    <mat-form-field class="filter-form-field">
      <mat-label>Search for a master drug by name</mat-label>
      <input #masterDrugSearch matInput type="text" [formControl]="masterDrugFormControl"
             data-qa="qa-input"
             (input)="onInputChangedFilterData('name')">
    </mat-form-field>
  </div>
  <span class="header-spacer"></span>
  <div>
    <button [routerLink]="'/pharmacy-management/add-master-drug'" mat-raised-button color="accent">
      <mat-icon>add</mat-icon>
      Add Master Drug
    </button>
  </div>
</div>

<div *ngIf="!masterDrugDataSource" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="masterDrugDataSource" class="mat-elevation-z8 table-container">
  
  <table mat-table multiTemplateDataRows [dataSource]="masterDrugDataSource" #masterDrugSort="matSort"
         matSort (matSortChange)="sortData($event)">
    
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" #editMasterDrugTooltip="matTooltip"
                  matTooltip="EDIT Master Drug" (click)="editEntry($event, row.masterDrugId)">edit
        </mat-icon>
        <mat-icon class="table-icon" #deleteMasterDrugTooltip="matTooltip"
                  matTooltip="DELETE Master Drug" (click)="deleteEntry($event, row.masterDrugId)">delete
        </mat-icon>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="masterDrugId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> ID</th>
      <td *matCellDef="let row" mat-cell> {{row.masterDrugId}}</td>
    </ng-container>
    
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Master Drug</th>
      <td *matCellDef="let row" mat-cell> {{row.name | slice:0:100}}</td>
    </ng-container>
    
    <ng-container matColumnDef="dosageForm">
      <th *matHeaderCellDef mat-header-cell> Dosage Form</th>
      <td *matCellDef="let row" mat-cell> {{row.dosageForm.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="startDate">
      <th *matHeaderCellDef mat-header-cell> Start Date</th>
      <td *matCellDef="let row" mat-cell> {{row.startDate | date: dateFormat}}</td>
    </ng-container>
    
    <ng-container matColumnDef="endDate">
      <th *matHeaderCellDef mat-header-cell> End Date</th>
      <td *matCellDef="let row" mat-cell> {{row.endDate | date: dateFormat}}</td>
    </ng-container>
    
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="masterDrugDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == masterDrugExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="masterDrugDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: masterDrugDisplayedColumns;" class="row"
        [class.expanded-row]="masterDrugExpandedRow == row"
        (click)="masterDrugExpandedRow = masterDrugExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  
  </table>
  
  <mat-paginator #masterDrugPaginator (page)="pageChanged($event)"
                 [length]="masterDrugTableControl.length" [pageSize]="masterDrugTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="masterDrugTableControl.pageSizeOptions">
  </mat-paginator>

</div>
